import { IContentControlStudioViewModel } from 'app/js/src/domain/content-control/studio';
import { IContentControlVideoSource } from 'app/js/src/domain/content-control/i-content-control-video-source';
import { StudioAudioManager } from './studio-audio-manager';

export class StudioAudioManagerVod extends StudioAudioManager {

  protected setupAudioContextImpl(
    audioCtx: AudioContext,
    gain: GainNode,
    videoContainer: HTMLDivElement,
    availableTracks: { [lang: string]: MediaElementAudioSourceNode },
  ): void {
    videoContainer
      .querySelectorAll("audio")
      .forEach((audioSource) => {
        const mes = audioCtx.createMediaElementSource(audioSource);
        mes.connect(gain);
        availableTracks[audioSource.getAttribute("lang")!] = mes;
      });
  }

  protected handleAudioOptionChangeImpl(
    option: string,
    availableTracks: { [lang: string]: MediaElementAudioSourceNode },
    video: IContentControlVideoSource,
    isVideoAudioTrack: boolean,
    syncAudioFn: () => void,
  ): void {
    for (const audioElement of Object.values(availableTracks)) {
      (audioElement as MediaElementAudioSourceNode).mediaElement.pause();
    }
    if (option === IContentControlStudioViewModel.VK) {
      video.muted = false;
    } else {
      video.muted = true;
      syncAudioFn();
    }
  }
}
